import BaseClient, { Response } from './Client';

export interface MemberWeddingResult {
  data: {
    updateWeddingWebsite: {
      id: number;
      hideDate: boolean;
    };
  };
}

export interface MemberWeddingLocationResult {
  data: {
    weddingWebsite: {
      weddingLocation: string;
    };
  };
}

type Param = { hideDate: boolean };

export interface MWClient {
  // For now only supporting hideDate
  updateMemberWedding: (data: Param) => Response<MemberWeddingResult>;
}

export class MemberWeddingClient extends BaseClient implements MWClient {
  public updateMemberWedding = ({ hideDate }: Param): Response<MemberWeddingResult> =>
    this.callWwsApi(`${this.getWwsHost(true)}/graphql`, {
      method: 'POST',
      data: {
        query: `mutation {\n  updateWeddingWebsite( attributes: { hideDate: ${hideDate} }) {\n    id\n    hideDate\n  }\n}`,
      },
    });

  public getMemberWeddingLocation = (): Response<MemberWeddingLocationResult> =>
    this.callWwsApi(`${this.getWwsHost(true)}/graphql`, {
      method: 'POST',
      data: {
        query: `query {\n  weddingWebsite {\n    weddingLocation\n    }\n}`,
      },
    });
}
